module.exports = __webpack_public_path__ + "assets/glidejs.f0565563.svg";